export enum DropdownMenuValues {
    PEER_COMPARE = 1,
    PERIOD_COMPARE,
    POPULATION_COMPARE,
    LAUNCH_RADIAL,
}
